const customNodes = {
    /*"/": {
        pattern: /.* /,
        _id: {},
        _custom: true,
        title: "",
    },*/
}
export default customNodes
